exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1ldj7{--wsr-font-family: var(--wix-font-stack);--wsr-font-weight-regular: var(--wix-font-weight-regular);--wsr-font-weight-bold: var(--wix-font-weight-bold)}\n", ""]);

// Exports
exports.locals = {
	"root": "_1ldj7"
};